import { render, staticRenderFns } from "./json-to-csv-button.vue?vue&type=template&id=c07f631e"
import script from "./json-to-csv-button.vue?vue&type=script&lang=js"
export * from "./json-to-csv-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c07f631e')) {
      api.createRecord('c07f631e', component.options)
    } else {
      api.reload('c07f631e', component.options)
    }
    module.hot.accept("./json-to-csv-button.vue?vue&type=template&id=c07f631e", function () {
      api.rerender('c07f631e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/buttons/json-to-csv-button.vue"
export default component.exports